import getConfig from 'getConfig';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {StepConfigModalSupportedStepType} from 'pipelines/generalized-step-config-editor/StepConfigEditorModal';
import * as Colors from 'ui-library/Colors';

/*
 * The `ADDABLE_TRANSFORMATION_STEPS` is organized as a list of lists to allow for sectioning in the dropdown.
 * Within each section, the order is sorted alphabetically by the corresponding value in `STEP_TYPE_TO_CREATION_METHOD_SUMMARY`
 *
 * Transforms gated by config flags (in `GATED_TRANSFORMATION_STEPS`) will appear in a new section (last).
 */
export const ADDABLE_TRANSFORMATION_STEPS = [
  // Simple transformations
  [
    {stepType: PipelineStepType.HIDE_COLUMNS, stepVersion: 0},
    {stepType: PipelineStepType.REORDER_COLUMNS, stepVersion: 0},
    {stepType: PipelineStepType.SORT_COLUMNS, stepVersion: 0},
  ],
  // Column transformations
  [
    {stepType: PipelineStepType.COMPUTED_COLUMN, stepVersion: 0},
    {stepType: PipelineStepType.WINDOW_FUNCTIONS, stepVersion: 0},
  ],
  [
    // Aggregations
    {stepType: PipelineStepType.AGGREGATE_DATASET, stepVersion: 0},
    {stepType: PipelineStepType.BIN_DATA, stepVersion: 0},
    {stepType: PipelineStepType.PIVOT_DATASET, stepVersion: 0},
    {stepType: PipelineStepType.UNPIVOT_DATASET, stepVersion: 0},
  ],
  [
    // Misc, table management, supposed to be rarely used
    {stepType: PipelineStepType.FIND_AND_REPLACE, stepVersion: 0},
    {stepType: PipelineStepType.RENAME_COLUMNS, stepVersion: 0},
    {stepType: PipelineStepType.RETYPE_COLUMNS, stepVersion: 0},
  ],
  // Not widely available
  getConfig('ENABLE_ANALYSIS_TOOL_REGRESSIONS')
    ? [{stepType: PipelineStepType.REGRESSION_INTERPOLATION, stepVersion: 0}]
    : [],
] as const satisfies ReadonlyArray<
  ReadonlyArray<{stepType: StepConfigModalSupportedStepType; stepVersion: number}>
>;

export const GATED_TRANSFORMATION_STEPS = [] as const satisfies ReadonlyArray<
  ReadonlyArray<{stepType: StepConfigModalSupportedStepType; stepVersion: number}>
>;

const STEPS_PADDING = 4;

export const SHARED_CONFIRMATION_BUTTON_STYLES = {
  marginLeft: 10,
  marginRight: 10,
};

export const SHARED_RIGHT_PANE_FOOTER_STYLES = {
  background: Colors.WHITE,
  alignSelf: 'flex-end' as 'flex-end',
  borderTop: `1px solid ${Colors.GRAY_LIGHT}`,
  display: 'flex' as 'flex',
  justifyContent: 'flex-end' as 'flex-end',
  position: 'sticky' as 'sticky',
  bottom: 0,
  paddingTop: 15,
  paddingBottom: 15,
  width: '100%',
};

export const SHARED_RIGHT_PANE_STYLES = {
  display: 'flex' as 'flex',
  flexDirection: 'column' as 'column',
  height: '100%',
  paddingTop: 12,
  paddingLeft: STEPS_PADDING,
  paddingRight: STEPS_PADDING,
  width: 232,
  flexShrink: 0,
  overflowY: 'auto' as 'auto',
};
